module.exports = __webpack_public_path__ + "static/media/cal_white.8d723c4a.svg";